import { render, staticRenderFns } from "./PostHeader.vue?vue&type=template&id=d7f5f9b8&scoped=true"
import script from "./PostHeader.vue?vue&type=script&lang=js"
export * from "./PostHeader.vue?vue&type=script&lang=js"
import style0 from "./PostHeader.vue?vue&type=style&index=0&id=d7f5f9b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f5f9b8",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PostHeader.vue
// module id = 304
// module chunks = 0